import { Container } from 'brandi';
import React from 'react';

export const ContainerContext = React.createContext<Container | null>(null);
